import { createContext } from 'react';

export interface IFormsAppContext {
  goToForms: (formId: string, locationIdSelected?: number) => void;
}

export const FormsAppContext = createContext<IFormsAppContext>(null!);
